import React from 'react'
import classnames from 'classnames'

import { Food, getFoodTranslation, FoodCategory } from '../../../core/foods'
import { LANGUAGE_CODES, SupportedLanguageCode } from '../../../core/i18n'
import { foodInfoTableContent } from './new-food-content'
import styles from '../../styles/modules/table.module.scss'
import formStyles from '../../styles/modules/each-food/each-food-forms.module.scss'

interface Props {
  food: Food
  activeLanguage: SupportedLanguageCode
  categories?: FoodCategory[]
  onChange: (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => void
}

const FoodInfoForm: React.FC<Props> = props => {
  const { activeLanguage } = props
  const isEnglishMode = activeLanguage === LANGUAGE_CODES.ENGLISH

  return (
    <div
      className={classnames({
        [styles.wrapper]: true,
        [styles.stocker]: true,
      })}
    >
      <table className={`${styles.container} ${styles.foodInfoTable}`}>
        <tbody>
          <tr className={styles.inputRowStatic}>
            <td className={styles.inputCell}>{foodInfoTableContent.name}</td>
            <td className={styles.inputCell}>
              <input
                className={formStyles.input}
                value={
                  activeLanguage === LANGUAGE_CODES.JAPANESE
                    ? props.food.name || ''
                    : getFoodTranslation(
                        props.food.foodTranslations,
                        LANGUAGE_CODES.ENGLISH
                      )?.name || ''
                }
                onChange={props.onChange}
                name={
                  activeLanguage === LANGUAGE_CODES.JAPANESE
                    ? 'name'
                    : 'foodTranslations.en_US.name'
                }
              />
            </td>
          </tr>
          <tr className={styles.inputRowStatic}>
            <td className={styles.inputCell}>{foodInfoTableContent.price}</td>
            <td className={styles.inputCell}>
              <input
                className={formStyles.input}
                value={props.food.price || ''}
                onChange={props.onChange}
                name="price"
                disabled={isEnglishMode}
                style={isEnglishMode ? { opacity: 0.5 } : {}}
              />
            </td>
          </tr>
          {props.categories && (
            <tr className={styles.inputRowStatic}>
              <td className={styles.inputCell}>カテゴリ</td>
              <td className={styles.inputCell}>
                <select
                  className={formStyles.input}
                  value={props.food.category || ''}
                  onChange={props.onChange}
                  name="category"
                  disabled={isEnglishMode}
                  style={isEnglishMode ? { opacity: 0.5 } : {}}
                >
                  <option value="">未設定</option>
                  {props.categories.map(category => (
                    <option key={category.id} value={category.categoryCode}>
                      {category.displayName}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default FoodInfoForm
